import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const pageProgressElement = css`
	.CodeMirror {
		height: auto;
		border: 1px solid ${colors.border};
		border-radius: 4px;
		font-size: 12px;
	}

	.form-label {
		margin-bottom: 0;
		font-size: 12px;
		color: #757575;
	}

	.block {
		margin-top: 35px;
	}
`;
